import { styleOverrides } from "./styleOverridesx";

const MuiAvatar = {
  styleOverrides,
};

export { MuiAvatar };
